module.exports = __webpack_public_path__ + "img/detailLogo.7bdf5663.png";